// extracted by mini-css-extract-plugin
module.exports = {"SenceCard":"SenceCard_SenceCard__gmnZ_"};